import { Request } from 'commons/utils/request'

import { HistoryEntityType } from '../enums'

export const getDirectDownloadLinkByEntityType = (type: HistoryEntityType): string => {
  switch (type) {
    case HistoryEntityType.DOCUMENT_FILE:
      return Request.urls.bank.documentFileDirectDownload
    case HistoryEntityType.ADVERSE_MEDIA_SCAN_RESULT:
      return Request.urls.bank.adverseMediaScanResultDownload
    default:
      return ''
  }
}
